import { render, staticRenderFns } from "./ContactsCard.vue?vue&type=template&id=302d9fac"
import script from "./ContactsCard.vue?vue&type=script&lang=js"
export * from "./ContactsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports